export default __webpack_public_path__ + "static/media/utility2.616c592b.svg";